import { gql } from 'apollo-angular';

export const FicheConfigDetailled = gql`
  fragment FicheConfigDetailled on AdequationRulesConfig {
    id
  }
`;

export const FullConditionsOfApplicabilityFragment = gql`
  fragment FullConditionsOfApplicability on ConditionsOfApplicability {
    id
    typeInvestisseur
    enveloppe {
      code
      libelle
      type2Navigation {
        code
        libelle
        gammeNavigation {
          code
          libelle
        }
      }
    }
    habilitation {
      id
      libelle
    }
    natureOperation {
      id
      libelle
      categorieNavigation {
        id
        libelle
      }
    }
  }
`;
